
/** 
 * @locked-file 
 * 注意：此处包含用户上传的真实文章内容。
 * 除非用户明确要求修改文字，否则请勿改动此文件。
 */
import { Article, FAQItem, NavItem, Photo } from './types';

export const ASSETS = {
  profilePhoto: 'https://yanyuassets-1394872578.cos.ap-chengdu.myqcloud.com/chenruixuelarge.jpg',
  bookingQR: 'https://yanyuassets-1394872578.cos.ap-chengdu.myqcloud.com/tengcentqr.png', 
  wechatQR: 'https://yanyuassets-1394872578.cos.ap-chengdu.myqcloud.com/wetchat.jpg',
  workshopQR: 'https://yanyuassets-1394872578.cos.ap-chengdu.myqcloud.com/wetchat.jpg',
  studio: {
    overview: 'https://yanyuassets-1394872578.cos.ap-chengdu.myqcloud.com/blanket.jpeg', // 心理舒毯
    detail1: 'https://yanyuassets-1394872578.cos.ap-chengdu.myqcloud.com/timeandpuzzle.jpeg', // 时间与拼图
    detail2: 'https://yanyuassets-1394872578.cos.ap-chengdu.myqcloud.com/drinkbar.jpeg', // 茶水区
    detail3: 'https://yanyuassets-1394872578.cos.ap-chengdu.myqcloud.com/studio.jpeg', // 窗边光影
    detail4: 'https://yanyuassets-1394872578.cos.ap-chengdu.myqcloud.com/painting.jpeg', // 画作
  }
};

export const NAV_ITEMS: NavItem[] = [
  { id: 'home', label: '启程' },
  { id: 'about', label: '关于我' },
  { id: 'articles', label: '咨询手记' },
  { id: 'space', label: '工作空间' },
  { id: 'workshops', label: '活动工坊' },
  { id: 'booking', label: '预约设置' },
  { id: 'mood', label: '情绪空间' },
];

export const ARTICLES: Article[] = [
  {
    id: '1',
    title: '为何在咨询室「谈话」会有疗效？',
    summary: '一生当中，我们说过太多话。和朋友吐槽，和家人争执，在日记里倾倒心事。奇怪的是，同样是「说」，只有在咨询室里，它被叫作「谈话治疗」...',
    content: ` 一生当中，我们说过太多话。
和朋友吐槽，和家人争执，在日记里倾倒心事。
奇怪的是，同样是「说」，
只有在咨询室里，它被叫作「谈话治疗」。
为什么在咨询室里，谈话会疗愈会改变？

一、同情 VS 共情，井口和井底的区别
老师课上有过一个比喻：
同情，是你在井底，对方站在井口。
TA 真心希望你能爬上来，会说“加油””你可以的”，甚至你半天爬不出来 ta 会为你担忧、着急。亦会在安全地带扔你一根绳索。

而共情则是冒险跳进井底，
和你一起闻到黑暗中潮湿的味道，一起感到绝望、孤独和无助，
然后才慢慢商量：我们要不要试着往上爬？
如果今天爬不动，那就先坐在这里，至少你不是一个人。
没有受过训练的人，如何能轻易下井呢？

二、共情：需要卷入和体力
有些咨询师做完一节咨询，真的会汗流浃背。
不是因为说了多少话，而是因为在这 50min 里，ta 做了几件反人性、反直觉的事：

第一，不急着把你从“坏情绪”里拽出来
大多数人看到别人难受，第一反应是：「别想了」「出去走走就好了」。
有时候是在帮自己减轻不适——见不得你痛，所以赶紧往外拉一拉。
而咨询师却反其道而行：和你一起待在痛苦和不确定里——因为那是你一直生活的地方。

第二，允许原始的情绪将自己裹挟
你的羞耻、愤怒、被抛弃感，如上身一般，会在咨询师身体里面真实的晃动。
ta 不是隔着玻璃看你，而是让自己短暂地站到你的位置。
但 ta 又必须从这个位置出来，和你一起出来。

第三，在没有被淹没的前提下「消化」
比昂把这称为「涵容」（containment）：
把来访难以消化的情绪装进咨询师内在的「容器」里，在里面沉淀、分类、命名，再用可以被你吸收、理解的方式返还给你。

所以，咨询师得在井底陪着你，又不能完全失去方向。
要一边感受，一边摸索，心里不停在想：这一切对你意味着什么？我们下一步可以往哪里挪半步？你现在是想离开，还是想再多待一会儿？

三、咨询室里有何魔法
当你对朋友说「我快撑不住了」时，收获的多半是安慰、建议、评价，或是对方的“励志”故事。这些都很珍贵，是从井口飘来的真切关心。

那为什么咨询室不一样，为什么咨询可能产生改变呢?
我觉得，咨询室里发生的改变，最终的荣光都归于来访：
也许是终于有人不再催促 ta「快点好起来」；
也许是第一次，有人不再责怪 ta「怎么又掉进井里」。

ta 被允许留在井底一会儿，被允许感受自己的存在——
在这个被看见、被涵容的过程中，生命动力慢慢绽放。`,
    date: '', 
    readTime: '6 min read'
  },
  {
    id: '2',
    title: '有时候觉得周遭的声音被放大',
    summary: '当身体感到危险，感官会被无限调高。这不是顺风耳，而是“过度警觉”在站岗。失眠、肠胃紧绷、感官过载，其实都是神经系统在试图保护你...',
    content: ` 有时候，你会发现马路的噪声、水滴声甚至邻居的脚步声都变得清晰可闻。这不是你的听觉变好了，而是神经系统进入了“过度警觉”模式。

一、这不是顺风耳，而是“过度警觉”上线
当身体感到“有什么危险正在靠近”，听觉是最先被调高的系统。你不是“听觉变好了”。而是在过度警觉（hypervigilance）的状态下，听觉通道原本用于过滤无关刺激的「滤波器」被暂时关闭，很多平时会被忽略的声音，被完整地送进意识。
声音会变得具象化：
*马路车流穿梭的声音
*楼道里微弱的动静
*家里水龙头滴落的声响
这是身体在高度警觉的站岗：“我得确保我们是安全的。”

二、这不是不想睡，是身体不允许你睡
此等失眠状态，不是“焦虑太多”，也不是“脑子停不下来”。而是神经系统判断：现在不能休息，要观察周围，要保持清醒，因为正处于“危险”之中。
于是你会经历：
*极度困倦，却无法真正入睡
*即使睡着，也很浅、很碎
*梦里反复处理应激事件
对神经系统来说，此刻「保持清醒」，比「睡一个好觉」更加重要。

三、这不是肠胃崩溃，而是迷走神经在排序
当交感神经过载时，身体会进行一次快速而本能的优先级调整。负责“休息与消化”的那一部分迷走神经会退缩到角落。
于是出现：腹泻、绞痛、紧绷、食欲下降。
这并不是肠胃突然「变得很脆弱」，而是身体在进行一场快速的能量重分配：「暂时不要消化食物，先把资源留给“战或逃”的行动。」
优先保障“活下来”。

四、终于不是回到过去，而是“过去在当下激活”
创伤并不总以“记忆”的形式存在，它常以身心状态的方式被储存。当当下的情境触碰到相似的情感轨迹，神经系统会自动调出那套生存的身体记忆：
*同样的警觉
*同样的睡眠困难
*同样的躯体反应
这并不是复发，而是一种激活。

五、这不是在失控，而是在被“保护”
如果你曾有过类似的感受，请先对自己温柔一些。你不是在“失控”，而是在被一套曾经救过你的神经系统，过度保护着。
你现在要做的不是“马上好起来”，而是先帮身体校准一件事。
你可以试试，在心里、轻声对自己说：
“现在是______（现在的年份），
我现在在 ______（说出你所在的地方），
此时此刻，是安全的。”
这是在给身体重新定位，校准时间和地点，让神经系统慢慢意识到：危险已经不再逼近了。`,
    date: '', 
    readTime: '7 min read'
  }
];

export const FAQS: FAQItem[] = [
  {
    question: '心理动力学咨询适合我吗？',
    answer: '如果你不仅仅想缓解当下的症状（如焦虑、抑郁），更希望探索自我、理解重复出现的人际模式、原生家庭影响，以及渴望在人格层面获得成长与整合，动力学咨询非常适合。'
  },
  {
    question: '咨询的频率与稳定性',
    answer: '通常建议每周 1-2 次，每次 50 分钟。固定的时间与频率能为您提供一个稳定的心理容器 (Holding Environment)。'
  },
  {
    question: '关于请假与边界',
    answer: '咨询关系需要双方共同维护。如需取消或改期，请至少提前 24 小时告知。'
  },
  {
    question: '关于保密与伦理',
    answer: '您在咨询室内的所有言行都受到严格保密。'
  }
];

export const STUDIO_PHOTOS: Photo[] = [
  { 
    url: ASSETS.studio.detail1, 
    title: '时间与拼图', 
    caption: 'Time & Puzzles', 
    description: '搜寻记忆碎片。在耐心与时间里，走向整合。',
    rotation: '-2deg' 
  },
  { 
    url: ASSETS.studio.detail2, 
    title: '温润的容器', 
    caption: 'Warm Container', 
    description: '摄入能量，在吸收在转化。',
    rotation: '1deg' 
  },
  { 
    url: ASSETS.studio.detail3, 
    title: '静默的见证', 
    caption: 'Silent Witness', 
    description: '空间本身就是咨询中沉默的参与者',
    rotation: '-1deg' 
  },
  { 
    url: ASSETS.studio.detail4, 
    title: '画中的回响', 
    caption: 'Echo in the Mirror', 
    description: '谈论自由，是为了从压抑中夺回真实自我。',
    rotation: '2deg' 
  },
  { 
    url: ASSETS.studio.overview, 
    title: '心理舒“毯”', 
    caption: 'Psychological Comfort', 
    description: '在这里，你不必懂事。感受先于一切定义。',
    rotation: '-1.5deg' 
  },
];
